/**
 * Creates a debounced function that delays invoking `fn` until after `delay`
 * milliseconds have elapsed since the last invocation.
 *
 * @param {Function} fn - The function to debounce
 * @param {number} [delay=300] - Milliseconds to wait
 * @returns {Function} The debounced function (with .cancel() method)
 */
export function debounce(fn, delay = 300) {
  let timerId = null;

  function debounced(...args) {
    if (timerId !== null) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      timerId = null;
      fn(...args);
    }, delay);
  }

  debounced.cancel = () => {
    if (timerId !== null) {
      clearTimeout(timerId);
      timerId = null;
    }
  };

  return debounced;
}
